import moment from "moment";
import React from "react";
import { Tooltip } from '@gpstrackit/gtc-react-controls';

const DEFAULT_IMAGE_URL = '/assets/images/'
export const getInitialRange = (value, startDate, endDate, enableToday) => {
    let start, end;

    switch (value) {
        case 'today':
            start = moment.utc().startOf('day').toDate();
            end = moment.utc().endOf('day').toDate();
            break;

        case 'yesterday':
            start = moment.utc().subtract(1, 'days').startOf('day').toDate();
            end = moment.utc().subtract(1, 'days').endOf('day').toDate();
            break;

        case 'tomorrow':
            start = moment.utc().add(1, 'days').startOf('day').toDate();
            end = moment.utc().add(1, 'days').endOf('day').toDate();
            break;

        case 'week':
            start = moment.utc().startOf('week').startOf('day').toDate();
            end = enableToday ? moment.utc().endOf('day').toDate() : moment.utc().subtract(1, 'days').endOf('day').toDate();
            break;

        case 'lastWeek':
            start = moment.utc().subtract(1, 'weeks').startOf('week').toDate();
            end = enableToday ? moment.utc().endOf('day').toDate() : moment.utc().subtract(1, 'weeks').endOf('week').toDate();
            break;

        case 'thisMonth':
            start = moment.utc().startOf('month').toDate();
            end = enableToday ? moment.utc().endOf('day').toDate() : moment.utc().subtract(1, 'days').endOf('day').toDate();
            break;

        case 'lastMonth':
            start = moment.utc().subtract(1, 'months').startOf('month').toDate();
            end = moment.utc().subtract(1, 'months').endOf('month').toDate();
            break;

        case 'quarter':
            start = moment.utc().startOf('quarter').toDate();
            end = moment.utc().endOf('quarter').toDate();
            break;

        case 'lastQuarter':
            start = moment.utc().subtract(1, 'quarter').startOf('quarter').toDate();
            end = moment.utc().subtract(1, 'quarter').endOf('quarter').toDate();
            break;

        case 'last7days':
            start = moment.utc().subtract(7, 'days').startOf('day').toDate();
            end = enableToday ? moment.utc().endOf('day').toDate() : moment.utc().subtract(1, 'days').endOf('day').toDate();
            break;

        case 'last15days':
            start = moment.utc().subtract(15, 'days').startOf('day').toDate();
            end = enableToday ? moment.utc().endOf('day').toDate() : moment.utc().subtract(1, 'days').endOf('day').toDate();
            break;

        case 'last30Days':
            start = moment.utc().subtract(30, 'days').startOf('day').toDate();
            end = enableToday ? moment.utc().endOf('day').toDate() : moment.utc().subtract(1, 'days').endOf('day').toDate();
            break;

        case 'last90days':
            start = moment.utc().subtract(90, 'days').startOf('day').toDate();
            end = enableToday ? moment.utc().endOf('day').toDate() : moment.utc().subtract(1, 'days').endOf('day').toDate();
            break;

        case 'last24hours':
            start = moment.utc().subtract(24, 'hours').startOf('hour').toDate();
            end = moment.utc().endOf('hour').toDate();
            break;

        case 'next7days':
            start = moment.utc().startOf('day').toDate();
            end = moment.utc().add(7, 'days').endOf('day').toDate();
            break;

        case 'next15days':
            start = moment.utc().startOf('day').toDate();
            end = moment.utc().add(15, 'days').endOf('day').toDate();
            break;

        case 'nextMonth':
            start = moment.utc().add(1, 'months').startOf('month').toDate();
            end = moment.utc().add(1, 'months').endOf('month').toDate();
            break;

        case 'next30Days':
            start = moment.utc().startOf('day').toDate();
            end = moment.utc().add(30, 'days').endOf('day').toDate();
            break;

        case 'next90Days':
            start = moment.utc().startOf('day').toDate();
            end = moment.utc().add(90, 'days').endOf('day').toDate();
            break;

        case "custom":
            start = startDate ? moment(startDate).startOf('day').toDate() : moment().startOf('day').toDate();
            end = endDate ? moment(endDate).endOf('day').toDate() : moment().endOf('day').toDate();
            break;

        default:
            start = moment.utc().startOf('month').toDate();
            end = moment.utc().endOf('month').toDate();
            break;
    }

    return { start, end };
};

export const getEventIcon = (status, disputed, messages, iconStyle) => {
    let BaseIcon = null;

    if (!messages) return null;

    switch (status) {
        case "falsepositive":
            BaseIcon = () => <img style={{ width: 24, height: 24 }} src={`${DEFAULT_IMAGE_URL}dr_error.svg`} alt="error" />;
            break;
        case "highlightcoaching":
            BaseIcon = () => <img style={{ width: 27, height: 27 }} src={`${DEFAULT_IMAGE_URL}dr_yelowCheck.svg`} alt="highlightcoaching" />;
            break;
        case "verified":
            BaseIcon = () => <img style={{ width: 23, height: 23 }} src={`${DEFAULT_IMAGE_URL}dr_blackCheck2.svg`} alt="noissue" />;
            break;
        case "noissue":
            BaseIcon = () => <img style={{ width: 27, height: 25 }} src={`${DEFAULT_IMAGE_URL}dr_folder.svg`} alt="noissue" />;
            break;
        default:
            BaseIcon = null;
    }

    if (!BaseIcon && !disputed) return null;

    if (!BaseIcon && disputed) {
        BaseIcon = () => <img style={{ width: 20, height: 20 }} src={`${DEFAULT_IMAGE_URL}dr_warning.svg`} alt="error" />;
        return (
            <Tooltip title={messages[`driver_performance_${status}`] || status}>
                <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center" }}>
                    <BaseIcon />
                </span>
            </Tooltip>
        )
    }

    if (BaseIcon && disputed) {
        return (
            <Tooltip title={`${messages && messages[`driver_performance_${status}`] ? messages[`driver_performance_${status}`] : status} (${messages['driver_performance_disputed']})`}>
                <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: iconStyle?.width, height: iconStyle?.height }}>
                    <img src={`${DEFAULT_IMAGE_URL}dr_warning.svg`} alt="disputed" style={{ width: 15, height: 15, marginRight: -10, marginTop: -12 }} />
                    <BaseIcon />
                </span>
            </Tooltip>
        );
    }

    return (
        <Tooltip title={messages[`driver_performance_${status}`] || status}>
            <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center" }}>
                <BaseIcon />
            </span>
        </Tooltip>
    );
}

export const removeDiacritics = (text) => {
  return text
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

}